<template>
	<div id="selectDiv" class="selectDiv">
        <div id="guestNameDiv">
            <div id="spreadsheet_guest_name_title" class="spreadsheetInputDiv">
                Guest Name
            </div>
            <div class="spreadsheetInput"> 
                <input v-model="Guest" type="text" id="spreadsheet_guest_name" placeholder="Guest Name">
            </div>
        </div>
        
        <div id="createSpreadsheetButton" @click="submitCreateSpreadsheet()">
            CREATE
        </div>
	</div>
</template>

<script>
    export default {
        data() {
            return {
                Guest: ""
            }
        },
        updated() {
            document.getElementById('spreadsheet_guest_name').focus();
        },
        methods: {
            submitCreateSpreadsheet() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('generate', {'event_category': 'spreadsheet_form','event_label': eventLabel});
                
                let input = {};
                input['headerGuestInfo'] = this.Guest;
                input['limit_count'] = 250;
                input['SortField'] = 'BOB';
                input['SortDirection'] = false;
                input['selectedVins'] = this.$store.getters.getSelectedVins;
                input['headerProductSpecialist'] = this.$store.getters.getAuthUserFullName;
                input['skip_rows'] = 0;

                this.$store.dispatch('generateAdminSpreadsheet', input);
                this.$store.commit('updateOpenSpreadsheetForm', false);
            }
        }
    }
</script>

<style scoped>
    .spreadsheetInput {
        color: black;
        width: 70%;
    }

    .spreadsheetInput > input {
        width: calc(100% - (1 * var(--vw)));
        height: calc(3 * var(--vh));
        border-radius: 1calc(var(--vratio) * 2 * var(--vh));/*0px;*/
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        background-color: #eee;
        outline: none;
        padding: 0 calc(.5 * var(--vw));
    }

    .inmobile .spreadsheetInput > input {
        border-radius: 5px;
    }

    #spreadsheet_guest_name_title {
        width: 30%;
    }

    #guestNameDiv {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: calc(2* var(--vh)) 0;
        width: 98%;
    }
    
    #selectDiv {
        position: absolute;
        width: calc(20 * var(--vw));
        padding: calc(1 * var(--vw));
        display: flex;
        left: calc(1 * var(--vw));
        top: calc(4.5 * var(--vh));
        z-index: 1;
        background-color: #2B2A2B;
        color: white;
        flex-direction: column;
        border-radius: calc(var(--vratio) * 2 * var(--vh));/*10px;*/
        justify-content: center;
        align-items: center;
    }

    .inmobile #selectDiv {
        width: calc(90 * var(--vw));
        height: calc(14 * var(--vh));
        border-radius: 5px;
    }

    #createSpreadsheetButton {
        background-color: var(--mccluskeyBlue);/*#0077C0;*/ /*#0079B6;*/ /*#AF873F;*/
        border-radius: calc(var(--vratio) * var(--vh));/*5px;*/
        width: calc(8.5 * var(--vw));
        height: calc(1.8 * var(--vw));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bold;
        color: white;
        /*font-size: 2.2vh;*/
        border: solid white .75px;
    }

    .inmobile #createSpreadsheetButton {
        width: calc(28.5 * var(--vw));
        height: calc(4.8 * var(--vw));
        border-radius: 5px;
    }
    
    #createSpreadsheetButton:hover {
        color: black;
        border: #AF873F;
    }
</style>
